import { Injectable } from '@angular/core';

export interface OfferExpirationTime {
  label: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class OffersService {

  private _offers: string[] = [
    'Free First Exam',
    'Free Training Class',
    '50% off Training',
    'First Week Free',
    'First Exam Discount',
    'First Visit Discount',
    'Free Day',
  ];

  private _expirationTime: OfferExpirationTime[] = [
    {
      label: 'Never Expires',
      value: '-1'
    },
    {
      label: '3 Days',
      value: '3'
    },
    {
      label: '7 Days',
      value: '7'
    },
    {
      label: '14 Days',
      value: '14'
    },
    {
      label: '30 Days',
      value: '30'
    },
    {
      label: '60 Days',
      value: '60'
    },
    {
      label: '90 Days',
      value: '90'
    },
    {
      label: '6 Months',
      value: '183'
    },
    {
      label: '1 Year',
      value: '365'
    },
  ];

  constructor() { }

  get offers(): string[] {
    return this._offers;
  }

  get expirationTime(): OfferExpirationTime[] {
    return this._expirationTime;
  }
}
